import { Container, Text, Group } from "@mantine/core";
import { IconHeart } from "@tabler/icons-react";
import classes from "./Footer.module.css";

export function Footer({ data }) {
    return (
        <footer className={classes.footer}>
            <Container size='lg'>
                <Group justify='center' align='center'>
                    <Text size='sm' c='dimmed'>
                        © {new Date().getFullYear()} {data.personalInfo.name}.
                        Všechna práva vyhrazena.
                    </Text>
                </Group>
            </Container>
        </footer>
    );
}
